// extracted by mini-css-extract-plugin
export default {"countWords":"src-components-CountWords-CountWords__countWords--3lCAl"};